$(document).ready(function () {
  $(".atd-dropdown-collection-carousel").owlCarousel({
    loop: false,
    nav: false,
    dots: true,
    slideTransition: "linear",
    margin: 0,
    // touchDrag: false,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2.25,
      },
      1200: {
        items: 4,
      },
    },
  });
});

const activeDropdown = document.querySelector(".active-dropdown");
const dropdownWrapper = document.querySelector(".dropdown-selector");
const dropdownIcon = document.querySelector(".dropdown-selector .icon");
const dropdown = document.querySelector(".dropdown-collection");
const dropdownItems = document.querySelectorAll(
  ".dropdown-collection .dropdown-item"
);
const dropdownCollections = document.querySelectorAll(
  ".collection-dropdown-products-container .dropdown-collections"
);

dropdownCollections?.forEach((collection, index) => {
  if (index === 0) collection.classList.add("active-collection");
});

dropdownWrapper.addEventListener("click", () => {
  dropdown.classList.toggle("show-dropdown");
  dropdownIcon.classList.toggle("toggled");
});

dropdownItems?.forEach((item, index) => {
  item.addEventListener("click", (e) => {
    activeDropdown.textContent = item.textContent;

    dropdownCollections?.forEach((collection) => {
      collection.classList.remove("active-collection");
      if (item.id === collection.id)
        collection.classList.add("active-collection");
    });
  });
});
